import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { vars } from "./assets";

Object.entries(vars).forEach(([key, value]) => {
  document.documentElement.style.setProperty(`--${key}`, value);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
